import Dashboard from "Pages/Dashboard/Dashboard";
import HomeIcon from "Assets/Icons/HomeIcon";
import HomeOutlineIcon from "Assets/Icons/HomeOutlineIcon";
import PlannerViewHome from "Pages/PlannerView/PlannerViewHome";
import PDFViewIcon from "Assets/Icons/PDFViewIcon";
import PDFViewOutlineIcon from "Assets/Icons/PDFViewOutlineicon";
import GraphIcon from "Assets/Icons/GraphIcon";
import GraphIconOutline from "Assets/Icons/GraphIConOutline";
import TestPerformanceCommentHome from "Pages/TestPerformance/TestPerformanceCommentHome";
import FacultyBatch from "Pages/FacultiesAntd/FacultyBatch/FacultyBatch";
import BatchIcon from "Assets/Icons/BatchIcon";
import BatchOutlineIcon from "Assets/Icons/BatchIconOutline";
import ScheduleIcon from "Assets/Icons/ScheduleIcon";
import ScheduleActiveIcon from "Assets/Icons/ScheduleActiveIcon";
import MyLibraryIcon from "Assets/Icons/MyLibraryIcon";
import MyLibraryHomePage from "Pages/MyLibrary/MyLibraryHomePage";
import MyLibraryUnselectedIcon from "Assets/Icons/MyLibraryUnselectedIcon";
import MyUserManagement from "Pages/UserManagement/MyUserManagement";
import UserGroupIcon from "Assets/Icons/UserGroupIcon";
import UserGroupActiveIcon from "Assets/Icons/UserGroupActiveIcon";
import BranchHealthActiveIcon from "Assets/Icons/BranchHealthActiveicon";
import BranchHealthIcon from "Assets/Icons/BranchHealthIcon";
import BranchHealthHome from "Pages/BranchHealth/BranchHealthHome";
import SyllabusCompliancesBatchMain from "Pages/SyllabusCompliances/SyllabusCompliancesBatchMain";
import FacultiesMain from "Pages/Faculties/FacultiesMain";
import { UserRoles as UR } from "utilFunctions/Constants/UserRoles";
import UploadPlannerHome from "Pages/PlannerView/UploadPlannerFile/UploadPlannerHome";
import FAQ from "Pages/PlannerView/FAQ/FAQ";
import FacultyContentMain from "Pages/MyLibrary/FacultyContent/FacultyContentMain";
import BranchStudentHome from "Pages/BranchHealth/BranchStudentHome";
import SyllabusComplianceIcon from "Assets/Icons/SyllabusComplianceIcon";
import SyllabusComplianceInactiveIcon from "Assets/Icons/SyllabusComplianceInactiveIcon";
import FacultiesActiveIcon from "Assets/Icons/FacultiesActiveIcon";
import FacultiesInactiveIcon from "Assets/Icons/FacultiesInactiveIcon";
import MyScheduleHome from "Pages/MySchedule/MyScheduleHome";
import SupportHelpIcon from "Assets/Icons/SupportHelpIcon";
import MyBatchMain from "Pages/MyBatches/MyBatch/MyBatchMain";
import MyProfileHome from "Pages/MyProfile/MyProfileHome";
import MyBatchTestSyllabus from "Pages/MyBatchTestSyllabus/MyBatchTestSyllabus";
import Notifications from "Pages/Notifications/Notifications";
import AttendanceHome from "Pages/MySchedule/Attendance/AttendanceHome";
import UserNotifications from "Pages/User-Notifications/UserNotifications";
import MyBatchesAntd from "Pages/MyBatchesAntd/MyBatchesAntd";
import FacultiesRegions from "Pages/FacultiesAntd/Regions/FacultiesRegions";
import FacultiesBranches from "Pages/FacultiesAntd/Branches/FacultiesBranches";
import FacultiesBranch from "Pages/FacultiesAntd/Branches/FacultiesBranch";
import StudentSearchHistoryMain from "Pages/StudentHistory/StudentSearchHistoryMain";
import AIHintHomePage from "Pages/AIHintsVerification/AIHintHomePage";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { QuestionCircleFilled } from "@ant-design/icons";
const routes = [
  {
    collapse: false,
    icon: <HomeOutlineIcon />,
    activeIcon: <HomeIcon />,
    path: "/admin/dashboard",
    label: "Dashboard",
    keyName: "dashboard",
    miniName: "D",
    component: <Dashboard />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    collapse: false,
    icon: <GraphIconOutline />,
    activeIcon: <GraphIcon />,
    path: "/admin/performance",
    label: "Performances",
    keyName: "performance",
    miniName: "P",
    component: <StudentSearchHistoryMain />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.academicCounsellor,
    ],
  },

  {
    collapse: false,
    icon: <ScheduleIcon />,
    activeIcon: <ScheduleActiveIcon />,
    path: "/admin/schedule",
    label: "My Schedule",
    keyName: "schedule",
    miniName: "MS",
    component: <MyScheduleHome />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    icon: <BatchIcon />,
    activeIcon: <BatchOutlineIcon />,
    miniName: "MB",
    keyName: "batches",
    label: "My Batches",
    path: "/admin/batches",
    collapse: false,
    component: <MyBatchesAntd />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    collapse: false,
    icon: <PDFViewIcon />,
    activeIcon: <PDFViewOutlineIcon />,
    path: "/admin/planner",
    label: "Planner",
    keyName: "planner",
    miniName: "PV",
    component: <PlannerViewHome />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    icon: <MyLibraryUnselectedIcon />,
    activeIcon: <MyLibraryIcon />,
    miniName: "MB",
    keyName: "mylibrary",
    label: "My Library",
    path: "/admin/mylibrary",
    collapse: false,
    component: <MyLibraryHomePage />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    icon: (
      <svg
        width="48"
        height="2"
        viewBox="0 0 48 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1H48" stroke="#AFAFAF" />
      </svg>
    ),
    keyName: "System Health",
    label: "System Health",
    path: "",
    collapse: false,
    access: [UR.academicHead, UR.regionalHead, UR.nationalHead, UR.NADTeam],
  },
  {
    icon: <BranchHealthActiveIcon />,
    activeIcon: <BranchHealthIcon />,
    miniName: "MB",
    keyName: "myBranch",
    label: "LOP Dashboard",
    path: "/admin/myBranch",
    collapse: false,
    component: <BranchHealthHome />,
    access: [
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.academicCounsellor,
    ],
  },
  {
    icon: <SyllabusComplianceInactiveIcon />,
    activeIcon: <SyllabusComplianceIcon />,
    miniName: "SC",
    keyName: "syllabusCompliances",
    label: "Syllabus Compliance",
    path: "/admin/syllabusCompliances",
    collapse: false,
    component: <SyllabusCompliancesBatchMain />,
    access: [UR.academicHead, UR.regionalHead, UR.nationalHead, UR.NADTeam],
  },
  {
    icon: <FacultiesInactiveIcon />,
    activeIcon: <FacultiesActiveIcon />,
    miniName: "SC",
    keyName: "faculties",
    label: "Faculty Performance",
    path: "/admin/faculties/regions",
    collapse: false,
    component: <FacultiesRegions />,
    access: [
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.branchEDP,
    ],
  },
  {
    icon: (
      <QuestionCircleOutlined
        style={{
          fontSize: "22px",
          color: "#757575",
        }}
      />
    ),
    activeIcon: (
      <QuestionCircleFilled
        style={{
          fontSize: "22px",
          color: "white",
        }}
      />
    ),
    miniName: "MB",
    keyName: "Hints",
    label: "Hints verification",
    path: "/admin/hintsverification",
    collapse: false,
    component: <AIHintHomePage />,
    access: [
      UR.faculty,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    icon: <UserGroupIcon />,
    activeIcon: <UserGroupActiveIcon />,
    miniName: "UM",
    keyName: "userManagement",
    label: "User Management",
    path: "/admin/userManagement",
    collapse: false,
    component: <MyUserManagement />,
    access: [UR.branchEDP, UR.nationalHead, UR.NADTeam],
  },
  {
    icon: <UserGroupIcon />,
    activeIcon: <UserGroupActiveIcon />,
    miniName: "NN",
    keyName: "notifications-service",
    label: "Notifications-Service",
    path: "/admin/notifications-service",
    collapse: false,
    component: <Notifications />,
    access: [UR.nationalHead, UR.NADTeam],
  },

  {
    icon: <SupportHelpIcon />,
    activeIcon: <SupportHelpIcon />,
    miniName: "FQ",
    keyName: "faq",
    key: "faq",
    path: "/admin/faq",
    label: "Help Center",
    component: <FAQ />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  // {
  //   icon: <LogoutIcon />,
  //   keyName: "Logout",
  //   label: "Logout",
  //   path: "",
  //   collapse: false,
  //   access: [
  //     UR.faculty,
  //     UR.branchEDP,
  //     UR.academicHead,
  //     UR.regionalHead,
  //     UR.nationalHead,
  //     UR.NADTeam,
  //   ],
  // },
];
export const dynamicRoutes = [
  {
    key: "uploadPlanner",
    path: "/admin/planner/uploadPlanner",
    component: <UploadPlannerHome />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    key: "faq",
    path: "/admin/faq",
    component: <FAQ />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    key: "mylibrary",
    path: "/admin/mylibrary/:id",
    component: <FacultyContentMain />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    key: "myBranchStudent",
    path: "/admin/myBranch/:id",
    component: <BranchStudentHome />,
    access: [
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.academicCounsellor,
    ],
  },
  {
    key: "performance",
    path: "/admin/performance/:id",
    component: <TestPerformanceCommentHome />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.academicCounsellor,
    ],
  },
  {
    key: "mybatch",
    path: "/admin/mybatch/:id",
    component: <MyBatchMain />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    key: "mybatch",
    path: "/admin/mybatch/test/:id",
    component: <MyBatchTestSyllabus />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    key: "batches",
    path: "/admin/faculties/:id",
    component: <FacultyBatch />,
    access: [
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.branchEDP,
      UR.faculty,
    ],
  },
  {
    key: "batches",
    path: "/admin/myprofile/:id",
    component: <MyProfileHome />,
    access: [
      UR.faculty,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.branchEDP,
      UR.academicCounsellor,
    ],
  },
  {
    keyName: "faculties",
    path: "/admin/faculties/branches/:id",
    collapse: false,
    component: <FacultiesBranches />,
    access: [
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.branchEDP,
    ],
  },
  {
    keyName: "faculties",
    path: "/admin/faculties/details",
    collapse: false,
    component: <FacultiesMain />,
    access: [
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.branchEDP,
    ],
  },
  {
    keyName: "faculties",
    path: "/admin/faculties/branch/:id",
    collapse: false,
    component: <FacultiesBranch />,
    access: [
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
      UR.branchEDP,
    ],
  },
  {
    keyName: "schedule",
    path: "/admin/schedule/attendance/:id",
    collapse: false,
    component: <AttendanceHome />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
  {
    icon: <MyLibraryUnselectedIcon />,
    activeIcon: <MyLibraryIcon />,
    miniName: "MB",
    keyName: "notifications",
    label: "Notifications",
    path: "/admin/notifications",
    collapse: false,
    component: <UserNotifications />,
    access: [
      UR.faculty,
      UR.branchEDP,
      UR.academicHead,
      UR.regionalHead,
      UR.nationalHead,
      UR.NADTeam,
    ],
  },
];

export default routes;
